import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { getZaloOAs, type ZaloOA } from "@api/services/zalo";

export type { ZaloOA };

export interface ZaloState {
  oas: ZaloOA[];
  loading: boolean;
  error: string | null;
}

const initialState: ZaloState = {
  oas: [],
  loading: false,
  error: null,
};

export const fetchZaloOAs = createAsyncThunk(
  "zalo/fetchZaloOAs",
  async (_, { rejectWithValue }) => {
    try {
      const oas = await getZaloOAs();
      return oas;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error
          ? error.message
          : "Failed to fetch Zalo OAs"
      );
    }
  }
);

const zaloSlice = createSlice({
  name: "zalo",
  initialState,
  reducers: {
    clearOAs: (state) => {
      state.oas = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchZaloOAs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchZaloOAs.fulfilled,
        (state, action: PayloadAction<ZaloOA[]>) => {
          state.loading = false;
          state.oas = action.payload;
          state.error = null;
        }
      )
      .addCase(fetchZaloOAs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearOAs } = zaloSlice.actions;
export default zaloSlice.reducer;

